import React from 'react'

export const ProfileScreen = () => {
  return (
    <div>detail</div>
  )
}
